<template>
  <span v-on="$listeners" class="badge">
    <Icon v-if="icon" :icon="icon" class="badge__icon" />
    <!-- custom content -->
    <slot></slot>
  </span>
</template>

<script>
import Icon from 'Ui/AppIcon'

export default {
  name: 'Badge',
  components: {
    Icon,
  },

  props: {
    className: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px;
  border-radius: 4px;
  background-color: var(--c-primary);
}

.badge__icon {
  font-size: 14px;
  color: var(--c-secondary-700);
}

.badge span {
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  color: #fff;
}
</style>
